/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Card,
  Checkbox,
  Dropdown,
  Form,
  Image,
  Radio,
  Switch,
} from "antd";
import IconCustomerManagement from "../../../../../atoms/CustomIcons/IconCustomerManagement";
import {
  InputField,
  InputNumberField,
  InputTextArea,
  TextEditor,
} from "../../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { MoreOutlined } from "@ant-design/icons";
import { DeleteIcon, PlusIcon } from "../../../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { updateCompanySettings } from "../../ducks/services";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { getCompanyFieldsById } from "../../../TagsCategories/ducks/actions";

interface PropsType {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function CustomerManagement(props: PropsType) {
  const { setLoading } = props;
  const [textChecked, setTextChecked] = useState(false);
  const [textChecked2, setTextChecked2] = useState(false);
  const [textChecked3, setTextChecked3] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
  const [emailChecked2, setEmailChecked2] = useState(false);
  const [emailChecked3, setEmailChecked3] = useState(false);

  const [isFollowupEnabled, setIsFollowupEnabled] = useState(false);
  const [isDayBeforeEnabled, setIsDayBeforeEnabled] = useState(false);
  const [isHourBeforeEnabled, setIsHourBeforeEnabled] = useState(false);
  const [isTiming, setTiming] = useState("ONE_HOUR");
  const { control, handleSubmit, setValue } = useForm();
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];

  const settingsData = useAppSelector((state) => state?.tags?.tagData);

  useEffect(() => {
    if (companyId && serviceLineId) {
      const payload = {
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId, serviceLineId]);

  useEffect(() => {
    if (settingsData) {
      const followupItem: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "1_FOLLOWUP_IN_DAYS"
      );
      const textMessageContent: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "1_TEXT_MESSAGE_CONTENT"
      );
      const emailContent: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "1_EMAIL_CONTENT"
      );
      const emailSubject: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "1_EMAIL_SUBJECT"
      );
      const isFollowupEnabled: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "AUTOMATIC_FOLLOWUP_ENABLED"
      );

      const dayBefore: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "DAY_BEFORE_REMINDER_ENABLED"
      );
      const dayMessageContent: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "DAY_BEFORE_REMINDER_TEXT_MESSAGE_ENABLED"
      );
      const dayEmailContent: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "DAY_BEFORE_REMINDER_EMAIL_CONTENT"
      );
      const dayEmailSubject: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "DAY_BEFORE_REMINDER_EMAIL_SUBJECT"
      );

      const visitReminder: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "VISIT_DAY_REMINDER_ENABLED"
      );
      const visitTiming: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "VISIT_DAY_REMINDER_TIMING"
      );
      const visitMessageContent: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "VISIT_DAY_REMINDER_TEXT_MESSAGE_ENABLED"
      );
      const visitEmailContent: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "VISIT_DAY_REMINDER_EMAIL_CONTENT"
      );
      const visitEmailSubject: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "VISIT_DAY_REMINDER_EMAIL_SUBJECT"
      );

      setIsHourBeforeEnabled(visitReminder?.value === "true");
      console.log("visitTiming?.value", visitTiming?.value);
      setTiming(visitTiming?.value || "ONE_HOUR");

      if (visitMessageContent) {
        setTextChecked3(true);
        setValue(
          "VISIT_DAY_REMINDER_TEXT_MESSAGE_ENABLED",
          visitMessageContent?.value || ""
        );
      }

      if (visitEmailContent || visitEmailSubject) {
        setEmailChecked3(true);
        setValue(
          "VISIT_DAY_REMINDER_EMAIL_CONTENT",
          visitEmailContent?.value || ""
        );
        setValue(
          "VISIT_DAY_REMINDER_EMAIL_SUBJECT",
          visitEmailSubject?.value || ""
        );
      }

      setIsDayBeforeEnabled(dayBefore?.value === "true");

      if (dayMessageContent) {
        setTextChecked2(true);
        setValue(
          "DAY_BEFORE_REMINDER_TEXT_MESSAGE_ENABLED",
          dayMessageContent?.value || ""
        );
      }

      if (dayEmailContent || dayEmailSubject) {
        setEmailChecked2(true);
        setValue(
          "DAY_BEFORE_REMINDER_EMAIL_CONTENT",
          dayEmailContent?.value || ""
        );
        setValue(
          "DAY_BEFORE_REMINDER_EMAIL_SUBJECT",
          dayEmailSubject?.value || ""
        );
      }

      setIsFollowupEnabled(isFollowupEnabled?.value === "true");

      if (textMessageContent) {
        setTextChecked(true);
        setValue("1_TEXT_MESSAGE_CONTENT", textMessageContent?.value || "");
      }

      if (emailContent || emailSubject) {
        setEmailChecked(true);
        setValue("1_EMAIL_CONTENT", emailContent?.value || "");
        setValue("1_EMAIL_SUBJECT", emailSubject?.value || "");
      }

      setValue("1_FOLLOWUP_IN_DAYS", Number(followupItem?.value ?? 0));
    }
  }, [settingsData, setValue]);

  const onSubmit = (data: any) => {
    console.log("Form Data:", data);

    setLoading(true);
    const payload = [];

    if (isFollowupEnabled) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
        name: "AUTOMATIC_FOLLOWUP_ENABLED",
        value: "true",
      });
    }

    if (data?.["1_FOLLOWUP_IN_DAYS"] > 0) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
        name: "1_FOLLOWUP_IN_DAYS",
        value: data?.["1_FOLLOWUP_IN_DAYS"].toString(),
      });
    }

    if (textChecked) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
        name: "1_TEXT_MESSAGE_CONTENT",
        value: data?.["1_TEXT_MESSAGE_CONTENT"],
      });
    }

    if (emailChecked) {
      payload.push(
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "1_EMAIL_CONTENT",
          value: data?.["1_EMAIL_CONTENT"],
        },
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "1_EMAIL_SUBJECT",
          value: data?.["1_EMAIL_SUBJECT"],
        }
      );
    }

    if (isDayBeforeEnabled) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
        name: "DAY_BEFORE_REMINDER_ENABLED",
        value: "true",
      });
    }

    if (textChecked2) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
        name: "DAY_BEFORE_REMINDER_TEXT_MESSAGE_ENABLED",
        value: data?.["DAY_BEFORE_REMINDER_TEXT_MESSAGE_ENABLED"],
      });
    }

    if (emailChecked2) {
      payload.push(
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "DAY_BEFORE_REMINDER_EMAIL_CONTENT",
          value: data?.["DAY_BEFORE_REMINDER_EMAIL_CONTENT"],
        },
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "DAY_BEFORE_REMINDER_EMAIL_SUBJECT",
          value: data?.["DAY_BEFORE_REMINDER_EMAIL_SUBJECT"],
        }
      );
    }

    if (isHourBeforeEnabled) {
      payload.push(
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "VISIT_DAY_REMINDER_ENABLED",
          value: "true",
        },
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "VISIT_DAY_REMINDER_TIMING",
          value: isTiming,
        }
      );
    }

    if (textChecked3) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CUSTOMER_MANAGEMENT",
        name: "VISIT_DAY_REMINDER_TEXT_MESSAGE_ENABLED",
        value: data?.["VISIT_DAY_REMINDER_TEXT_MESSAGE_ENABLED"],
      });
    }

    if (emailChecked3) {
      payload.push(
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "VISIT_DAY_REMINDER_EMAIL_CONTENT",
          value: data?.["VISIT_DAY_REMINDER_EMAIL_CONTENT"],
        },
        {
          company_id: companyId,
          service_line_id: serviceLineId,
          module: "CUSTOMER_MANAGEMENT",
          name: "VISIT_DAY_REMINDER_EMAIL_SUBJECT",
          value: data?.["VISIT_DAY_REMINDER_EMAIL_SUBJECT"],
        }
      );
    }

    updateCompanySettings(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Changes saved");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit
        </Button>
      ),
    },

    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <div style={{ width: "800px", margin: "0 auto" }}>
      <div>
        <h2 className="tabs_content_heading">
          <IconCustomerManagement /> Customer Management
        </h2>
        <p className="tabs_content_subheading">
          Customize your customer experience.
        </p>
      </div>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "0" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_cursor.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Automatic proposal follow-ups </h3>
                <p>
                  Send automatic reminders to customers who haven’t responded to
                  proposals. These rules apply to all properties unless
                  customized for a specific property.
                </p>
              </div>
              <div>
                <Switch
                  checked={isFollowupEnabled}
                  onChange={(checked) => setIsFollowupEnabled(checked)}
                  className="followup_switch"
                  disabled
                />
              </div>
            </div>
          </div>

          {isFollowupEnabled && (
            <>
              <div
                className="bordered_card followup_card"
                style={{ marginTop: "24px" }}
              >
                <h4 style={{ marginBottom: "20px" }}> First follow-up </h4>
                <div className="send_in_check">
                  Send in:
                  <InputNumberField
                    fieldName="1_FOLLOWUP_IN_DAYS"
                    label=""
                    control={control}
                    defaultValue={0}
                    iProps={{
                      placeholder: "Enter number",
                      min: 1,
                    }}
                  />
                  days
                </div>
                <div className="email_or_msg">
                  <p> Select notification method and edit its template: </p>
                  <div className="check_type">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Checkbox
                          checked={textChecked}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setTextChecked(checked);
                            if (checked) setEmailChecked(false); // clear email when text selected
                          }}
                        />
                        Text message
                      </span>

                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="actionButton"
                      >
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          style={{
                            padding: "6px",
                            height: "auto",
                            background: "transparent",
                          }}
                          className="only_icon"
                          icon={<MoreOutlined />}
                        />
                      </Dropdown>
                    </div>

                    {textChecked && !emailChecked && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "16px",
                          width: "100%",
                        }}
                      >
                        <InputTextArea
                          fieldName="1_TEXT_MESSAGE_CONTENT"
                          label=""
                          control={control}
                          iProps={{
                            placeholder: "Enter number",
                          }}
                        />
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button
                            style={{ width: "100%" }}
                            onClick={() => {
                              setTextChecked(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button style={{ width: "100%" }} type="primary">
                            Close
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="check_type">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Checkbox
                          checked={emailChecked}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setEmailChecked(checked);
                            if (checked) setTextChecked(false); // clear text when email selected
                          }}
                        />
                        Email
                      </span>

                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="actionButton"
                      >
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          style={{
                            padding: "6px",
                            height: "auto",
                            background: "transparent",
                          }}
                          className="only_icon"
                          icon={<MoreOutlined />}
                        />
                      </Dropdown>
                    </div>

                    {emailChecked && !textChecked && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "16px",
                          width: "100%",
                        }}
                      >
                        <InputField
                          fieldName="1_EMAIL_SUBJECT"
                          label="Email subject"
                          control={control}
                          defaultValue=""
                          className="category_input mb_0"
                          iProps={{
                            placeholder: "Email Subject",
                          }}
                          isRequired
                          rules={{
                            required: "Email Subject is required.",
                          }}
                        />
                        <div
                          style={{
                            gap: "4px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <TextEditor
                            fieldName="1_EMAIL_CONTENT"
                            label="Email text"
                            control={control}
                            iProps={{
                              placeholder:
                                "Compose your email template here...",
                            }}
                            className="customize_text_editor"
                          />
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button
                            style={{ width: "100%" }}
                            onClick={() => {
                              setEmailChecked(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button style={{ width: "100%" }} type="primary">
                            Close
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <Button
                htmlType="button"
                className="outlined-btn"
                type="primary"
                style={{ marginTop: "16px" }}
              >
                <PlusIcon /> Add follow-up
              </Button>
            </>
          )}
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_bell.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Upcoming visit reminders </h3>
                <p>
                  Choose how and when customers receive reminders about upcoming
                  visits. These rules apply to all properties unless customized
                  for a specific property.
                </p>
              </div>
            </div>
          </div>

          <div
            className="bordered_card visit_reminder_card"
            style={{ marginBottom: "12px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}> Day-before reminder </h4>
                <p style={{ color: "#6C7478" }}>
                  Send customers reminders &nbsp;
                  <span style={{ color: "#6C7478", fontWeight: "600" }}>
                    1 day before the visit
                  </span>
                  . You can adjust this in the property profile for each
                  customer.
                </p>
              </div>
              <div>
                <Switch
                  checked={isDayBeforeEnabled}
                  onChange={setIsDayBeforeEnabled}
                  className="day_before_switch"
                  disabled
                />
              </div>
            </div>

            {isDayBeforeEnabled && (
              <div className="email_or_msg" style={{ marginTop: "12px" }}>
                <p> Notification method: </p>
                <div className="check_type">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Checkbox
                        checked={textChecked2}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setTextChecked2(checked);
                          if (checked) setEmailChecked2(false); // clear email when text selected
                        }}
                      />{" "}
                      Text message
                    </span>

                    <Dropdown
                      menu={{ items }}
                      trigger={["click"]}
                      placement="bottomRight"
                      className="actionButton"
                    >
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onKeyDown={(e) => e.stopPropagation()}
                        style={{
                          padding: "6px",
                          height: "auto",
                          background: "transparent",
                        }}
                        className="only_icon"
                        icon={<MoreOutlined />}
                      />
                    </Dropdown>
                  </div>
                  {textChecked2 && !emailChecked2 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      <InputTextArea
                        fieldName="DAY_BEFORE_REMINDER_TEXT_MESSAGE_ENABLED"
                        label=""
                        control={control}
                        iProps={{
                          placeholder: "Enter number",
                        }}
                      />
                      <div style={{ display: "flex", gap: "8px" }}>
                        <Button
                          style={{ width: "100%" }}
                          onClick={() => {
                            setTextChecked2(false);
                          }}
                        >
                          Cancel
                        </Button>
                        <Button style={{ width: "100%" }} type="primary">
                          Close
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="check_type">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Checkbox
                        checked={emailChecked2}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setEmailChecked2(checked);
                          if (checked) setTextChecked2(false); // clear text when email selected
                        }}
                      />{" "}
                      Email
                    </span>

                    <Dropdown
                      menu={{ items }}
                      trigger={["click"]}
                      placement="bottomRight"
                      className="actionButton"
                    >
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onKeyDown={(e) => e.stopPropagation()}
                        style={{
                          padding: "6px",
                          height: "auto",
                          background: "transparent",
                        }}
                        className="only_icon"
                        icon={<MoreOutlined />}
                      />
                    </Dropdown>
                  </div>
                  {emailChecked2 && !textChecked2 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        marginTop: "16px",
                        width: "100%",
                      }}
                    >
                      <InputField
                        fieldName="DAY_BEFORE_REMINDER_EMAIL_SUBJECT"
                        label="Email subject"
                        control={control}
                        defaultValue=""
                        className="category_input mb_0"
                        iProps={{
                          placeholder: "Email Subject",
                        }}
                        isRequired
                        rules={{
                          required: "Email Subject is required.",
                        }}
                      />
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <TextEditor
                          fieldName="DAY_BEFORE_REMINDER_EMAIL_CONTENT"
                          label="Email text"
                          control={control}
                          iProps={{
                            placeholder: "Compose your email template here...",
                          }}
                          className="customize_text_editor"
                        />
                      </div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <Button
                          style={{ width: "100%" }}
                          onClick={() => {
                            setEmailChecked(false);
                          }}
                        >
                          Cancel
                        </Button>
                        <Button style={{ width: "100%" }} type="primary">
                          Close
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="bordered_card visit_reminder_card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}> Visit-day reminder </h4>
                <p style={{ color: "#6C7478" }}>
                  Send customers reminders &nbsp;
                  <span style={{ color: "#6C7478", fontWeight: "600" }}>
                    on the day of the visit
                  </span>
                  . You can adjust this in the property profile for each
                  customer.
                </p>
              </div>
              <div>
                <Switch
                  checked={isHourBeforeEnabled}
                  onChange={setIsHourBeforeEnabled}
                  className="visit_day_switch"
                  disabled
                />
              </div>
            </div>

            {isHourBeforeEnabled && (
              <>
                <p style={{ marginTop: "12px", marginBottom: "8px" }}>
                  Reminder timing:
                </p>
                <div className="reminder_radio">
                  <Radio.Group
                    name="radiogroup"
                    value={isTiming || "ONE_HOUR"}
                    options={[
                      { value: "ONE_HOUR", label: "1 hour" },
                      { value: "ONE_AND_HALF_HOUR", label: "1.5 hours" },
                      { value: "TWO_HOURS", label: "2 hours" },
                    ]}
                    onChange={(e) => setTiming(e.target.value)}
                  />
                </div>

                <div className="email_or_msg">
                  <p> Notification method: </p>
                  <div className="check_type">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Checkbox
                          checked={textChecked3}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setTextChecked3(checked);
                            if (checked) setEmailChecked3(false); // clear email when text selected
                          }}
                        />{" "}
                        Text message
                      </span>

                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="actionButton"
                      >
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          style={{
                            padding: "6px",
                            height: "auto",
                            background: "transparent",
                          }}
                          className="only_icon"
                          icon={<MoreOutlined />}
                        />
                      </Dropdown>
                    </div>

                    {textChecked3 && !emailChecked3 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "16px",
                          width: "100%",
                        }}
                      >
                        <InputTextArea
                          fieldName="VISIT_DAY_REMINDER_TEXT_MESSAGE_ENABLED"
                          label=""
                          control={control}
                          iProps={{
                            placeholder: "Enter number",
                          }}
                        />
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button
                            style={{ width: "100%" }}
                            onClick={() => {
                              setTextChecked3(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button style={{ width: "100%" }} type="primary">
                            Close
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="check_type">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Checkbox
                          checked={emailChecked3}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setEmailChecked3(checked);
                            if (checked) setTextChecked3(false); // clear text when email selected
                          }}
                        />{" "}
                        Email
                      </span>

                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="actionButton"
                      >
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          style={{
                            padding: "6px",
                            height: "auto",
                            background: "transparent",
                          }}
                          className="only_icon"
                          icon={<MoreOutlined />}
                        />
                      </Dropdown>
                    </div>
                    {emailChecked3 && !textChecked3 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "16px",
                          width: "100%",
                        }}
                      >
                        <InputField
                          fieldName="VISIT_DAY_REMINDER_EMAIL_SUBJECT"
                          label="Email subject"
                          control={control}
                          defaultValue=""
                          className="category_input mb_0"
                          iProps={{
                            placeholder: "Email Subject",
                          }}
                          isRequired
                          rules={{
                            required: "Email Subject is required.",
                          }}
                        />
                        <div
                          style={{
                            gap: "4px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <TextEditor
                            fieldName="VISIT_DAY_REMINDER_EMAIL_CONTENT"
                            label="Email text"
                            control={control}
                            iProps={{
                              placeholder:
                                "Compose your email template here...",
                            }}
                            className="customize_text_editor"
                          />
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button
                            style={{ width: "100%" }}
                            onClick={() => {
                              setEmailChecked(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button style={{ width: "100%" }} type="primary">
                            Close
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "0" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/icon_timer.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> End-of-visit reports for customers </h3>
                <p>
                  Configure which elements must be include in the report after
                  each visit for every service. These rules apply to all
                  properties unless customized for a specific property.
                </p>
              </div>
            </div>
          </div>
        </Card>

        <div style={{ textAlign: "right", width: "100%" }}>
          <Button
            htmlType="submit"
            className="mint-btn"
            style={{ marginTop: "10px" }}
          >
            Save changes
          </Button>
        </div>
      </Form>
    </div>
  );
}
